export default "__VITE_ASSET__wQpNq69v__"